import { Color, rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Themable } from '../../../../types/themable'

type GuideLayoutWrapperProps = Themable

export const GuideLayoutWrapper = styled.div<GuideLayoutWrapperProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Color.White};
  overflow-y: auto;

  ${rwd.equalOrLessThan('phone')} {
    padding-right: ${Spacing.S16};
    padding-left: ${Spacing.S16};
  }
`

export const LayoutContent = styled.div`
  display: flex;
  min-height: 100%;
`

const SideWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  width: 50%;

  ${rwd.equalOrLessThan('large')} {
    padding-right: ${Spacing.S24};
    padding-left: ${Spacing.S24};
  }
  ${rwd.equalOrLessThan('tablet')} {
    padding-right: ${Spacing.S16};
    padding-left: ${Spacing.S16};
  }
  ${rwd.equalOrLessThan('phone')} {
    align-items: flex-start;
    padding: 0;
  }
`

export const LeftSideWrapper = styled(SideWrapper)<Themable>`
  padding-top: ${Spacing.S40};
  padding-bottom: ${Spacing.S40};

  ${rwd.equalOrLessThan('tablet')} {
    width: 65%;
  }
  ${rwd.equalOrLessThan('phone')} {
    width: 100%;
    padding-top: ${Spacing.S16};
  }
`

export const LeftSideContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 428px;
  min-height: 100%;
  margin-bottom: ${Spacing.S32};

  ${rwd.equalOrLessThan('large')} {
    width: 100%;
    min-height: auto;
  }
`

export const LeftSizeHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${Spacing.S24};
  padding-top: ${Spacing.S16};
`

export const ContentWrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`

interface RightSideWrapperProps {
  imageSrc?: string
}

export const RightSideWrapper = styled(SideWrapper)<RightSideWrapperProps>`
  display: flex;
  background-color: ${Color.Grey150};
  background-position: 60px 60px;
  background-repeat: no-repeat;
  background-size: 95vh;
  overflow: hidden;
  ${({ imageSrc }) => `background-image: url(${imageSrc});`};

  ${rwd.equalOrLessThan('large')} {
    background-position: 30px 60px;
  }
  ${rwd.equalOrLessThan('tablet')} {
    width: 35%;
  }
  ${rwd.equalOrLessThan('phone')} {
    display: none;
  }
`

export const RightSideFooter = styled.footer`
  width: 850px;
  margin: 90vh auto auto -52px;

  ${rwd.equalOrLessThan('large')} {
    width: 250px;
    margin-left: -8px;
  }
  ${rwd.equalOrLessThan('tablet')} {
    display: none;
  }
`
